import { createIcon } from '@/utils/factoryUtil'

export const SVGBrandCardKingdom = createIcon('SVGBrandCardKingdom', (props) => (
  <svg viewBox='0 0 100 100' {...props}>
    <path d='M0,7.14v31.29h14.05v54.42h71.9v-54.42h14.05V7.14h-15.56v29.45h-13.28V7.33h-14.8v29.26h-12.71V7.33h-14.8v29.26h-13.28V7.14H0Z' />
  </svg>
))
